import React from 'react';
import PropTypes from 'prop-types';

import Settings from './RightPanel/Settings';
import SettingsV4 from './RightPanelV4/Settings';
import UserStatus from './RightPanel/Status/UserStatus';
import UserStatusV4 from './RightPanelV4/Status/UserStatus';
import Emoji from '../emoji/Emoji';
import EmojiUtils from '../../../../core/utils/emoji';
import TabTitle from './Tabs.styled';

export const getTabs = (status, flags) => {
  return [
    {
      title: (
        <TabTitle key="status_tab">
          Status
          {status?.emojiName ? (
            <Emoji emoji={EmojiUtils.getFromShortName(status.emojiName)} />
          ) : null}
        </TabTitle>
      ),
      key: 'status',
      component: flags.settingsModalUpgradeToMuiV6 ? UserStatus : UserStatusV4,
      visible: ({ ftUserStatusEnabled202107 }) => ftUserStatusEnabled202107,
    },
    {
      title: (
        <TabTitle key="notif-settings_tab">Notification settings</TabTitle>
      ),
      key: 'notif-settings',
      component: flags.settingsModalUpgradeToMuiV6 ? Settings : SettingsV4,
      visible: () => true,
    },
  ].filter((t) => t.visible(flags));
};

export const tabType = PropTypes.shape({
  title: PropTypes.shape({}),
  key: PropTypes.string.isRequired,
  component: PropTypes.elementType,
  onClick: PropTypes.func,
  TitleComponent: PropTypes.elementType,
});
